import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ManagementRoutingModule } from './management-routing.module';
import { AccountListingComponent } from './account-listing/account-listing.component';
import { AccountFormComponent } from './account-form/account-form.component';
import { BranchFormComponent } from './branch-form/branch-form.component';
import { BranchLisitngComponent } from './branch-lisitng/branch-lisitng.component';
import { ManagementParentComponent } from './management-parent/management-parent.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedComponentsModule } from 'src/app/shared-components/shared-components.module';
import { UserListingComponent } from './user-listing/user-listing.component';
import { UserFormComponent } from './user-form/user-form.component';


@NgModule({
  declarations: [
    AccountListingComponent,
    AccountFormComponent,
    BranchFormComponent,
    BranchLisitngComponent,
    ManagementParentComponent,
    UserListingComponent,
    UserFormComponent,
    
  ],
  imports: [
    CommonModule,
    ManagementRoutingModule,
    FormsModule,
    SharedComponentsModule,
    ReactiveFormsModule
  ]
})
export class ManagementModule { }
